import { render, staticRenderFns } from "./LightNavButtons.vue?vue&type=template&id=113aaf3c&scoped=true"
import script from "./LightNavButtons.vue?vue&type=script&lang=js"
export * from "./LightNavButtons.vue?vue&type=script&lang=js"
import style0 from "./LightNavButtons.vue?vue&type=style&index=0&id=113aaf3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113aaf3c",
  null
  
)

export default component.exports